import {
  LOGIN_DIALOG_OPEN,
  LOGIN_DIALOG_CLOSE,
  REMOTE_DIALOG_OPEN,
  REMOTE_DIALOG_CLOSE
} from 'types/actions/login-dialog'

import Deferred from 'node-deferred'

let deferred = null

export const _openLoginDialog = () => ({
  type: LOGIN_DIALOG_OPEN,
  open: true
})

export const _openRemoteDialog = () => ({
  type: REMOTE_DIALOG_OPEN,
  remoteControl: true
})

export const _closeRemoteDialog = () => ({
  type: REMOTE_DIALOG_CLOSE,
  remoteControl: false
})

export const openLoginDialog = data => {
  return dispatch => {
    deferred = new Deferred()
    window.top.postMessage(
      {
        liveApp: {
          action: 'openLoginDialog'
        }
      },
      '*'
    )
    return deferred.promise
  }
}

export const openRemoteDialog = data => {
  return dispatch => {
    dispatch(_openRemoteDialog())
    deferred = new Deferred()
    window.top.postMessage(
      {
        liveApp: {
          action: 'hideEventIFrame'
        }
      },
      '*'
    )
    return deferred.promise
  }
}

export const closeLoginDialog = (confirm, data) => {
  return dispatch => {
    if (deferred) {
      if (confirm) {
        deferred.resolve(data)
      } else {
        deferred.reject(data)
      }
      deferred = null
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/login-dialog.js